import React, {Component} from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Button from '../../../shared/components/Button';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';

import { textContains, alphabeticallySort, recursivelyLoadAllPages } from '../../../shared/utils';

class AccountList extends Component {
  constructor(){
    super();

    this.state = {
      isLoading:false,
    }
  }

  componentDidMount(){
    this.setState({isLoading:true});

    Promise.all([
      recursivelyLoadAllPages(this.props.loadAgencies,100),
      this.props.loadKPIsForAgencies()
    ])
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  render(){
    const accounts = this.props.accounts;

    return (
      <Container>
        <Row className='EntityList-title'>
          <Col xs='6'>
            <h1>Accounts</h1>
          </Col>
          <Col xs='6'>
            <Button
              className='pull-right'
              linkHref='/superadmin/accounts/new'
            >
              Create Account
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <SearchableDataTable 
              items={accounts}
              searchPromptText='Search by name'
              emptyText='Loading accounts...'
              columns={[
                {
                  display:'account',
                  name:'name',
                  width:50,
                  sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                  filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                  renderCell:(item) => (<Link to={`/superadmin/accounts/${item.id}/brands`}>{item.name}</Link>),
                },
                {
                  display:'brands',
                  name:'totalBrands',
                  width:15,
                  sortFunc:(a,b) => b.totalBrands - a.totalBrands,
                  renderCell:(item) => (<span>{(item.totalBrands || 0).toLocaleString()}</span>)
                },
                {
                  display:'budget',
                  name:'totalBudget',
                  width:15,
                  sortFunc:(a,b) => b.totalBudget - a.totalBudget,
                  renderCell:(item) => (<MoneyDisplay>{item.totalBudget || 0}</MoneyDisplay>)
                },
                {
                  width:20,
                  renderCell:(item) => (
                    <div className='pull-right'>
                      <Button
                        size='sm'
                        linkHref={`/superadmin/accounts/${item.id}/brands`}
                        textColor='#666666'
                        borderColor='#cccccc'
                        backgroundColor='#fff'
                      >
                        Edit
                      </Button>                      
                    </div>
                  )
                }  
              ]}            
            />
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default AccountList;



// WEBPACK FOOTER //
// ./src/routes/AccountList/components/AccountList.js